<template>
    <div>
        <modal :show.sync="viewMessage" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Información adicional</h6>
                <div class="alert alert-info mt-2">
                    <span v-html="informationalMessage"></span>
                </div>
            <template slot="footer">
                <div class="right-side">
                    <p-button type="default" link @click="cancelOpenMessage()">Aceptar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editCashFlow" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar Pago del crédito</h6>
            <div class="alert alert-warning mt-2">
                <span>El valor actual de Pago de crédito es: {{ setFormat(actualPaymentValue)}}</span>
            </div>
            <div class="form-group">
                <label>Nuevo valor *</label>
                <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="nuevo valor" v-validate="modelValidations.newPaymentValue" :error="getError('nuevo valor')" separator="." class="form-control" v-model="newPaymentValue"></vue-numeric>
                <span v-show="errors.has('nuevo valor')" class="text-danger" style="font-size: 11px;">
                    {{ errors.first('nuevo valor') }}
                </span>
            </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditCashFlow()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editCashFlowPayment()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-5">
                <h4 class="title center-title">VALORES FLUJO DE CAJA {{ quotaType }}</h4>
                <p-button @click="openMessage()" v-if="informationalMessage" class="top-right-button" type="primary"><i class="fa fa-cube"></i></p-button>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-body">
                <a href="#" @click.prevent="resetParameters()" class="top-right-button mr-4">
                    Restablecer parámetros
                </a>
                <el-table v-if="paymentPlan == 'Fija'" :data="payments"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange" @row-dblclick="showCashFlowDblClickMethod">
                    <el-table-column label="Meses" property="name"></el-table-column>
                    <el-table-column label="Pago del crédito">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.loanPayment )}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Deuda total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.totalDebt )}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Cap. de pago">
                        <template slot-scope="scope">
                            <span :class="getCapacityClass(scope.row.paymentCapacity)">{{ scope.row.paymentCapacity }}%</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table v-if="paymentPlan == 'Pactada'" :data="payments"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange" @row-dblclick="showCashFlowDblClickMethod">
                    <el-table-column label="Meses" property="name"></el-table-column>
                    <el-table-column label="Pago del crédito">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.loanPayment )}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Deuda total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.totalDebt )}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Valor abono a capital">
                        <template slot-scope="scope">
                            <span :class="getCapitalClass(scope.row)">{{ setFormat(scope.row.capital )}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Cap. de pago">
                        <template slot-scope="scope">
                            <span :class="getCapacityClass(scope.row.paymentCapacity)">{{ scope.row.paymentCapacity }}%</span>
                        </template>
                    </el-table-column>
                </el-table>
                <br>
                <div class="form-group">
                    <label>Observación</label>
                    <textarea
                        maxlength="150"
                        class="form-control"
                        name="observacion"
                        autocomplete="off"
                        v-validate="'max:150'" 
                        @input="validateInput"
                        v-model="agroCashFlowObservations">
                    </textarea>
                    <span v-show="errors.has('observacion')" class="text-danger">
                        {{ errors.first('observacion') }}
                    </span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveCashFlow()" type="warning">Siguiente</p-button>
            <p-button @click="toCashFlow()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, CardDark, Collapse, CollapseItem, Modal, Tabs, TabPane } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Table, TableColumn, DatePicker} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    import departments from 'src/util/Others/States'
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            TabPane,
            Tabs,
            Card,
            CardDark,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [DatePicker.name]: DatePicker
        },
        data() {
        return {
            creditParameters: null,
            cashFlowFamilyExpensesMonths: [],
            extraPayments: [],
            payments: [],
            informationalMessage: null,
            viewMessage: false,
            loanPayment : 0,
            assurancePayment: 0,
            agroCashFlowObservations: null,
            actualPaymentValue: 0,
            newPaymentValue: 0,
            editCashFlow: false,
            cashFlowMonths: null,
            paymentPlan: null,
            customerAge: null,
            quotaType: null,
            cashFlow: null,
            form: {
                cashFlowStartMonth: null,
                cashFlowFamilyExpensesMonths: null,
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            productName: '',
            productQuantity: '',
            productCostUnity: '',
            productSaleUnity: '',
            productCostTotal: '',
            productMonthlyCost: '',
            referenceName: '',
            referencePhone: '',
            referenceDescription: '',
            modelValidations: {
                average_selection: {
                    required: true
                },
                item_name: {
                    required: false
                },
            },
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                newPaymentValue: {
                    required: true
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.expenses': function (newVal, oldVal) {
                if (!newVal) {
                    this.actualExpenses = [];
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.inventory': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
            },
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalInventory != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalInventory ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalInventory() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].productCostTotal; 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            splitCashFlowIntoYears(cashFlowMonths) {
                console.log("📢 Dividiendo cashFlowMonths en bloques de 12 meses por año...");

                let groupedByYears = [];
                let currentYearGroup = { name: `Año 1`, months: [] };
                let yearIndex = 1;

                cashFlowMonths.forEach((monthData, index) => {
                    if (currentYearGroup.months.length === 12) {
                        // Si ya hay 12 meses, se inicia un nuevo año
                        groupedByYears.push(currentYearGroup);
                        yearIndex++;
                        currentYearGroup = { name: `Año ${yearIndex}`, months: [] };
                    }

                    // Agregar el mes al grupo actual
                    currentYearGroup.months.push(monthData);
                });

                // Agregar el último grupo si no está vacío
                if (currentYearGroup.months.length > 0) {
                    groupedByYears.push(currentYearGroup);
                }

                console.log("✅ División completada:", groupedByYears);
                return groupedByYears;
            },
            openMessage(){
                this.viewMessage = true;
            },
            cancelOpenMessage(){
                this.viewMessage = false;
            },
            resetParameters(){
                this.initParameters();
                this.showNotificationSuccess('Parámetros restablecidos correctamente');
            },
            findClientType(){
                const clientTypeId = this.cashFlow.clientType;
                const clientTypes = this.$store.getters.getClientTypes;
                const clientType = clientTypes.find(item => item.id === clientTypeId);
                const clientTypeName = clientType ? clientType.name : "Desconocido";
                return clientTypeName;
            },
            findCommissions(clientTypeName){
                const amount = this.$store.state.assesments[this.$store.state.actualAssesment].amount;
                const commissions = this.$store.getters.getCommissions;
                const foundRange = commissions.find(commission => 
                    amount >= parseFloat(commission.data.from) && amount <= parseFloat(commission.data.to)
                );
                const result = foundRange ? foundRange.data[clientTypeName] : "No encontrado";
                if(result === "No encontrado"){
                    this.showNotificationError('No hay comisiones parametrizadas para el tipo de cliente');
                }
                else {
                    return result;
                }
            },
            findCityType(){
                const state = this.cashFlow.state;
                const city = this.cashFlow.city;
                const foundItem = departments.find(dept => 
                    dept.Departamento === state && dept.Municipio === city
                );
                const modalidad = foundItem ? foundItem.Modalidad : "No encontrado";
                if(modalidad === "No encontrado"){
                    this.showNotificationError('No se ha encontrado la modalidad');
                }
                else {
                    return modalidad;
                }
                
            },
            findCreditRates(clientTypeName, cityType){
                const amount = this.$store.state.assesments[this.$store.state.actualAssesment].amount;
                const creditRates = this.$store.getters.getCreditRates;
                const foundRange = creditRates.find(rate => 
                    rate.data.active === true &&
                    amount >= parseFloat(rate.data.from) && 
                    amount <= parseFloat(rate.data.to) &&
                    cityType.toLowerCase() === rate.data.type.toLowerCase()
                );
                const result = foundRange ? foundRange.data[clientTypeName] : "No encontrado";
                if(result === "No encontrado"){
                    this.showNotificationError('No hay tasas de crédito parametrizadas para el tipo de cliente');
                }
                else {
                    return result;
                }
            },
            validateAssuranceParams(ageForAssurance, ageForAssurancePercentAbove, ageForAssurancePercentBelow) {
                const params = { ageForAssurance, ageForAssurancePercentAbove, ageForAssurancePercentBelow };
                
                for (const [key, value] of Object.entries(params)) {
                    if (value === null || value === undefined || value === "" || isNaN(value)) {
                        this.showNotificationError('No se han parametrizado correctamente los ítems de seguros');
                    }
                }
            },
            findAssuranceRate(){
                const age = this.customerAge;
                const ageForAssurance = this.$store.state.ageForAssurance;
                const ageForAssurancePercentAbove =  Number(this.$store.state.ageForAssurancePercentAbove).toFixed(4);
                const ageForAssurancePercentBelow =  Number(this.$store.state.ageForAssurancePercentBelow).toFixed(4);
                this.validateAssuranceParams(ageForAssurance,ageForAssurancePercentAbove,ageForAssurancePercentBelow);
                return age >= ageForAssurance ? ageForAssurancePercentAbove : ageForAssurancePercentBelow;
                
            },
            calculateLoanPayment(amount, monthlyRate, clientTerm) {
                if (!amount || !monthlyRate || !clientTerm) {
                    return null;
                }

                const rate = monthlyRate / 100; // Convertimos porcentaje a decimal
                const term = clientTerm; // Número de períodos (en meses)

                if (rate === 0) {
                    return Math.trunc(amount / term); // Si la tasa es 0, pago uniforme sin interés
                }

                const payment = (rate * amount) / (1 - Math.pow(1 + rate, -term));
                return payment; // Simulando ABS de Excel para evitar valores negativos
            },
            calculateAssurancePayment(amount, assuranceRate){
                const rate = assuranceRate / 100;
                const payment = (rate * amount);
                return payment;
            },
            calculateCommissionPayment(amount, commissionRate){
                const rate = commissionRate / 100;
                const payment = (rate * amount);
                return payment;
            },
            calculateCommissionIVAPayment(commissionPayment){
                const IVA = 19 / 100;
                const payment = (IVA * commissionPayment);
                return payment;
            },
            calculateTotalLoanPayment(loanPayment, assurancePayment, commissionPayment, commissionIVA){
                return loanPayment + assurancePayment + commissionPayment + commissionIVA;
            },
            calculatedInterests(balanceToCapital, creditRate, quota){
                const rate = creditRate / 100;
                let payment = 0
                if(quota == 0){
                    payment = ((rate * balanceToCapital) /30 * this.cashFlowData.daysDifference);
                }
                else {
                    payment = (rate * balanceToCapital);
                }
                return payment;
            },
            // generateCreditMessage(age, amount, clientTypeName, commissionRate, cityType, creditRate, assuranceRate, clientTerm, cashFlowData) {
            //     this.informationalMessage =  `El crédito tiene los siguientes parámetros:<br>
            //     <strong>Edad del cliente:</strong> ${age} años<br>
            //     <strong>Monto:</strong> ${amount.toLocaleString()}<br>
            //     <strong>Tipo de cliente:</strong> ${clientTypeName}<br>
            //     <strong>Tasa de comisión:</strong> ${commissionRate}%<br>
            //     <strong>Modalidad de ciudad:</strong> ${cityType}<br>
            //     <strong>Tasa de crédito:</strong> ${creditRate}%<br>
            //     <strong>Valor del seguro:</strong> ${assuranceRate.toLocaleString()}<br>
            //     <strong>Plazo:</strong> ${clientTerm} meses.<br>
            //     <strong>Desfase:</strong> ${cashFlowData.daysDifference} días.`;
            // },
            generateCreditMessage(age, amount, clientTypeName, commissionRate, cityType, creditRate, assuranceRate, clientTerm, daysDifference) {
                this.creditParameters = {
                    age,
                    amount,
                    clientTypeName,
                    commissionRate,
                    cityType,
                    creditRate,
                    assuranceRate,
                    clientTerm,
                    daysDifference,
                    loanPayment: this.loanPayment,
                    assurancePayment: this.assurancePayment
                };
                this.informationalMessage = `
                    El crédito tiene los siguientes parámetros:<br>
                    <strong>Edad del cliente:</strong> ${this.creditParameters.age} años<br>
                    <strong>Monto:</strong> ${this.creditParameters.amount.toLocaleString()}<br>
                    <strong>Tipo de cliente:</strong> ${this.creditParameters.clientTypeName}<br>
                    <strong>Tasa de comisión:</strong> ${this.creditParameters.commissionRate}%<br>
                    <strong>Valor cuota:</strong> ${this.creditParameters.loanPayment.toLocaleString()}<br>
                    <strong>Modalidad de ciudad:</strong> ${this.creditParameters.cityType}<br>
                    <strong>Tasa de crédito:</strong> ${this.creditParameters.creditRate}%<br>
                    <strong>Tasa de seguro:</strong> ${this.creditParameters.assuranceRate}%<br>
                    <strong>Plazo:</strong> ${this.creditParameters.clientTerm} meses.<br>
                    <strong>Desfase:</strong> ${this.creditParameters.daysDifference} días.`;
            },
            initParameters() {
                let amount = this.$store.state.assesments[this.$store.state.actualAssesment].amount;
                let clientTypeName = this.findClientType();
                let commisionRate = this.findCommissions(clientTypeName);
                let cityType = this.findCityType();
                let creditRate = this.findCreditRates(clientTypeName, cityType);
                let assuranceRate = this.findAssuranceRate();
                let clientTerm = this.cashFlow.clientTerm;
                this.loanPayment = this.calculateLoanPayment(amount,creditRate,clientTerm);
                this.assurancePayment = this.calculateAssurancePayment(amount,assuranceRate);
                this.generateCreditMessage(this.customerAge,amount, clientTypeName, commisionRate, cityType, creditRate, assuranceRate, clientTerm, this.cashFlowData.daysDifference)
                let _payments = [];
                let _extraPayments = [];
                let commissionPayment = 0;
                let commissionIVA = 0;
                let totalLoanPayment = 0;
                let interests = 0;
                let capital = 0;
                let totalDebt = 0;
                for (let i = 0; i < this.cashFlowData.months.length; i++) {
                    amount = amount - capital;
                    if ((i) % 12 === 0) {
                        commissionPayment = this.calculateCommissionPayment(amount,commisionRate);
                        commissionIVA = this.calculateCommissionIVAPayment(commissionPayment);
                    }
                    totalLoanPayment = this.calculateTotalLoanPayment(this.loanPayment, this.assurancePayment, commissionPayment, commissionIVA);
                    interests = this.calculatedInterests(amount, creditRate, i);
                    capital = this.loanPayment - interests;
                    totalDebt = amount + interests + commissionPayment + commissionIVA + this.assurancePayment;

                    const monthName = this.cashFlowData.months[i].name.split("/")[0]; // Extraer solo el mes (ej. "Abril" de "Abril/25")
                    // Buscar en cashFlowFamilyExpensesMonths un objeto cuyo mes coincida sin importar el año
                    const expenses = this.cashFlowFamilyExpensesMonths.cashFlowFamilyExpensesMonths.find(expense => 
                        expense.name.split("/")[0] === monthName
                    );

                    let familyExpensesTotal = expenses ? expenses.total : 0; // Si no encuentra, asigna 0

                    let paymentCapacity = familyExpensesTotal && familyExpensesTotal !== 0 
                    ? parseFloat((this.loanPayment / familyExpensesTotal * 100).toFixed(1)) 
                    : 0; // Evita división por cero, asignando 0 si no hay gastos familiares


                    _payments.push({
                        month: this.cashFlowData.months[i].month,
                        name: this.cashFlowData.months[i].name,
                        year: this.cashFlowData.months[i].year,
                        quota: i+1,
                        loanPayment: this.loanPayment,
                        assurancePayment: this.assurancePayment,
                        commission: commissionPayment,
                        commissionIVA: commissionIVA,
                        totalLoanPayment: totalLoanPayment,
                        interests: interests,
                        capital: capital,
                        balance: amount,
                        totalDebt: totalDebt,
                        familyExpensesTotal: familyExpensesTotal,
                        paymentCapacity: paymentCapacity,
                        newPayment: 0
                    });
                    _extraPayments.push({
                        month: this.cashFlowData.months[i].month,
                        name: this.cashFlowData.months[i].name,
                        year: this.cashFlowData.months[i].year,
                        quota: i+1,
                        newPayment: 0
                    });
                }
                this.payments = _payments;
                this.extraPayments = _extraPayments;
            },
            editParameters() {
                let amount = this.$store.state.assesments[this.$store.state.actualAssesment].amount;
                let clientTypeName = this.findClientType();
                let commisionRate = this.findCommissions(clientTypeName);
                let cityType = this.findCityType();
                let creditRate = this.findCreditRates(clientTypeName, cityType);
                let assuranceRate = this.findAssuranceRate();
                let clientTerm = this.cashFlow.clientTerm;
                this.generateCreditMessage(this.customerAge,amount, clientTypeName, commisionRate, cityType, creditRate, assuranceRate, clientTerm, this.cashFlowData.daysDifference)
                this.loanPayment = this.calculateLoanPayment(amount,creditRate,clientTerm);
                this.assurancePayment = this.calculateAssurancePayment(amount,assuranceRate);
                let _payments = [];
                let commissionPayment = 0;
                let commissionIVA = 0;
                let totalLoanPayment = 0;
                let interests = 0;
                let capital = 0;
                let totalDebt = 0;
                for (let i = 0; i < this.cashFlowData.months.length; i++) {
                    let extraCapital = 0;
                    amount = amount - capital;
                    if ((i) % 12 === 0) {
                        commissionPayment = this.calculateCommissionPayment(amount,commisionRate);
                        commissionIVA = this.calculateCommissionIVAPayment(commissionPayment);
                    }
                    totalLoanPayment = this.calculateTotalLoanPayment(this.loanPayment, this.assurancePayment, commissionPayment, commissionIVA);
                    interests = this.calculatedInterests(amount, creditRate, i);
                    if(this.extraPayments[i].newPayment != 0){
                        extraCapital = this.extraPayments[i].newPayment - this.loanPayment;
                    }
                    capital = this.loanPayment - interests + extraCapital;
                    totalDebt = amount + interests + commissionPayment + commissionIVA + this.assurancePayment;

                    const monthName = this.cashFlowData.months[i].name.split("/")[0]; // Extraer solo el mes (ej. "Abril" de "Abril/25")
                    // Buscar en cashFlowFamilyExpensesMonths un objeto cuyo mes coincida sin importar el año
                    const expenses = this.cashFlowFamilyExpensesMonths.cashFlowFamilyExpensesMonths.find(expense => 
                        expense.name.split("/")[0] === monthName
                    );

                    let familyExpensesTotal = expenses ? expenses.total : 0; // Si no encuentra, asigna 0

                    let paymentCapacity = familyExpensesTotal && familyExpensesTotal !== 0 
                    ? parseFloat(((this.loanPayment + extraCapital) / familyExpensesTotal * 100).toFixed(1)) 
                    : 0; // Evita división por cero, asignando 0 si no hay gastos familiares


                    _payments.push({
                        month: this.cashFlowData.months[i].month,
                        name: this.cashFlowData.months[i].name,
                        year: this.cashFlowData.months[i].year,
                        quota: i+1,
                        loanPayment: this.loanPayment + extraCapital,
                        assurancePayment: this.assurancePayment,
                        commission: commissionPayment,
                        commissionIVA: commissionIVA,
                        totalLoanPayment: totalLoanPayment,
                        interests: interests,
                        capital: capital,
                        balance: amount,
                        totalDebt: totalDebt,
                        familyExpensesTotal: familyExpensesTotal,
                        paymentCapacity: paymentCapacity,
                        newPayment: 0
                    });
                }
                this.payments = _payments;
            },
            validateInput(event) {
                // Permite solo letras, números y espacios
                this.agroCashFlowObservations = event.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]/g, '');
            },
            getCapacityClass(capacity) {
                if (capacity === null) return '';
                return capacity >= 75  ? 'highlight-red' : '';
            },
            // getCapitalClass(row) {
            //     const capital = row.capital / row.loanPayment * 100;
            //     if (capital === null) return '';
            //     return capital < 20  ? 'highlight-red' : '';
            // },
            getCapitalClass(row) {
                if (!row || typeof row.capital !== 'number' || typeof row.loanPayment !== 'number' || row.loanPayment === 0) {
                    return '';
                }

                const capital = (row.capital / row.loanPayment) * 100;
                
                return capital < 20 ? 'highlight-red' : '';
            },
            showCashFlowDblClickMethod(row){
                // Busca el índice del elemento dentro del array this.cashFlowMonths
                const matchedIndex = this.payments.findIndex(item => item.name === row.name);
                if (matchedIndex !== -1) {
                    this.currentRow = matchedIndex;
                    this.actualPaymentValue = this.payments[this.currentRow].loanPayment;
                    this.newPaymentValue = '';
                    this.editCashFlow = true;
                }
            },
            // Función para generar el primer array
            generateArray1(data) {
                return data.map(item => ({
                    name: item.name,
                    month: item.month,
                    year: item.year,
                    payment: this.loanPayment,
                    debt: 0,
                    capacity: 0
                }));
                // return data.map(item => ({
                //     name: item.name,
                //     month: item.month,
                //     year: item.year,
                //     payment: Math.floor(Math.random() * 600000) + 100000, // Valores aleatorios entre 100,000 y 700,000
                //     debt: Math.floor(Math.random() * 2500000) + 500000, // Valores aleatorios entre 500,000 y 3,000,000
                //     capacity: parseFloat((Math.random() * (80 - 20) + 20).toFixed(1)) // Valor numérico entre 20 y 80 con un decimal
                // }));
            },
            // Función para generar el segundo array
            generateArray2(data) {
                return data.map(item => ({
                    month: item.month,
                    year: item.year,
                    name: item.name,
                    payment: this.loanPayment,
                    debt: 0,
                    capacity: 0,
                    paymentCapital: 0
                }));
                // return data.map(item => ({
                //     month: item.month,
                //     year: item.year,
                //     name: item.name,
                //     payment: Math.floor(Math.random() * 600000) + 100000, // Valores aleatorios entre 100,000 y 700,000
                //     debt: Math.floor(Math.random() * 2500000) + 500000, // Valores aleatorios entre 500,000 y 3,000,000
                //     capacity: parseFloat((Math.random() * (80 - 20) + 20).toFixed(1)), // Valor numérico entre 20 y 80 con un decimal
                //     paymentCapital: Math.floor(Math.random() * 500000) + 10000 // Valores aleatorios entre 10,000 y 510,000
                // }));
            },
            validateCustomerAge() {
                if (
                    this.customerAge === null || // Es nula
                    this.customerAge === undefined || // Es indefinida
                    this.customerAge === '' || // Es una cadena vacía
                    isNaN(this.customerAge) || // No es un número
                    this.customerAge <= 0 // Es un número negativo o 0
                ) {
                    return false; // Indica que hay un error
                }
                return true; // Indica que es válido
            },
            handleDatePickerClick(){
                this.generateFamilyExpensesMonths(this.cashFlow.clientTerm);
            },
            generateFamilyExpensesMonths(term) {
                const MAX_TERM = 12; // Máximo de 12 meses adicionales
                const limitedTerm = Math.min(term, MAX_TERM); // Limitar el término al máximo permitido

                // Validar que cashFlowStartMonth sea un objeto Date válido
                if (!this.form.cashFlowStartMonth || !(this.form.cashFlowStartMonth instanceof Date)) {
                    console.error("cashFlowStartMonth debe ser un objeto Date válido.");
                    return;
                }

                // Obtener el mes y el año inicial
                const startMonth = this.form.cashFlowStartMonth.getMonth(); // Mes inicial (0 = enero)
                const startYear = this.form.cashFlowStartMonth.getFullYear(); // Año inicial

                const monthNames = [
                    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                ];

                // Crear los meses desde el mes inicial hasta limitedTerm meses adicionales
                this.form.cashFlowFamilyExpensesMonths = Array.from({ length: limitedTerm }, (_, i) => {
                    const totalMonths = startMonth + i; // Índice del mes total
                    const year = startYear + Math.floor(totalMonths / 12); // Ajustar el año si excede diciembre
                    const monthIndex = totalMonths % 12; // Índice del mes en el rango 0-11

                    return {
                        name: `${monthNames[monthIndex]}/${year.toString().slice(-2)}`, // Ejemplo: Enero/24
                        total: "", // Inicializa el total vacío
                    };
                });
            },
            validateAgroMicro () {
                if (this.$store.state.isCustomer) {
                    const countStudies = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length;
                    if(countStudies > 1){
                        var firstProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                        if(firstProduct.name.toLowerCase() == 'agropecuario'){
                            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)  
                            if(product.name.toLowerCase() == 'microcrédito'){
                                return true
                            }
                            else {
                                return false
                            }
                        }
                        else {
                            return false
                        }
                        
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.products.push({
                            referenceName: this.referenceName,
                            referencePhone: this.referencePhone,
                            referenceDescription: this.referenceDescription
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Producto agregado correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.referenceName = '';
                this.referencePhone = '';
                this.referenceDescription = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.referenceName= this.currentRow.referenceName;
                this.referencePhone= this.currentRow.referencePhone;
                this.referenceDescription= this.currentRow.referenceDescription;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editCashFlowPayment () {
                let indexRow = this.currentRow;
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            this.extraPayments[indexRow].newPayment = this.newPaymentValue;
                            this.$refs.productsTable.setCurrentRow();
                            this.editCashFlow = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Pago editado correctamente');
                            this.resetCashFlow();
                            this.currentRow = null;
                            this.editParameters();
                        }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditCashFlow () {
                this.editCashFlow = false;
                this.errors.clear();
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetCashFlow () {
                this.actualPaymentValue = 0;
                this.newPaymentValue = 0;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toCashFlow () {
                this.$router.push('/asessments/new_asessment/customer/agro/cash_flow');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCashFlow () {
                let groupedByYears = this.splitCashFlowIntoYears(this.payments);
                const payload = {
                    creditParameters: this.creditParameters,
                    cashFlowMonths: this.payments,
                    groupedByYears: groupedByYears,
                    extraPayments: this.extraPayments,
                    agroCashFlowObservations: this.agroCashFlowObservations || ''
                };
                this.$store.dispatch('setAgrocashFlowFull', payload).then(()=>{
                    this.$router.push('/asessments/new_asessment/customer/others/financial_indicators');
                });
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                this.customerAge = this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerAge;
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
                this.cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow;
                this.cashFlowFamilyExpensesMonths = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowFamilyExpensesMonths;
                this.agroCashFlowObservations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowObservations;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowFull) {
                    this.payments = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowFull;
                    this.creditParameters = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.creditParameters;
                    this.extraPayments = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.extraPayments;
                    this.loanPayment = this.creditParameters.loanPayment;
                    this.assurancePayment = this.creditParameters.assurancePayment;
                    this.generateCreditMessage(this.creditParameters.age, this.creditParameters.amount, this.creditParameters.clientTypeName, this.creditParameters.commissionRate, this.creditParameters.cityType, this.creditParameters.creditRate, this.creditParameters.assuranceRate, this.creditParameters.clientTerm, this.creditParameters.daysDifference);
                }
                else {
                    this.initParameters();
                }
            }
            else if (this.$store.state.isSpouse) {
                this.customerAge = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerAge;
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
                this.cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlow;
                this.cashFlowFamilyExpensesMonths = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowFamilyExpensesMonths;
                this.agroCashFlowObservations = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.agroCashFlowObservations;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowFull) {
                    this.payments = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowFull;
                    this.creditParameters = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.creditParameters;
                    this.extraPayments = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.extraPayments;
                    this.loanPayment = this.creditParameters.loanPayment;
                    this.assurancePayment = this.creditParameters.assurancePayment;
                    this.generateCreditMessage(this.creditParameters.age, this.creditParameters.amount, this.creditParameters.clientTypeName, this.creditParameters.commissionRate, this.creditParameters.cityType, this.creditParameters.creditRate, this.creditParameters.assuranceRate, this.creditParameters.clientTerm, this.creditParameters.daysDifference);
                }
                else {
                    this.initParameters();
                }
            }
            else if (this.$store.state.isGuarantor) {
                this.customerAge = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerAge;
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
                this.cashFlow = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlow;
                this.cashFlowFamilyExpensesMonths = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowFamilyExpensesMonths;
                this.agroCashFlowObservations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.agroCashFlowObservations;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowFull) {
                    this.payments = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowFull;
                    this.creditParameters = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.creditParameters;
                    this.extraPayments = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.extraPayments;
                    this.loanPayment = this.creditParameters.loanPayment;
                    this.assurancePayment = this.creditParameters.assurancePayment;
                    this.generateCreditMessage(this.creditParameters.age, this.creditParameters.amount, this.creditParameters.clientTypeName, this.creditParameters.commissionRate, this.creditParameters.cityType, this.creditParameters.creditRate, this.creditParameters.assuranceRate, this.creditParameters.clientTerm, this.creditParameters.daysDifference);
                }
                else {
                    this.initParameters();
                }
            }
            this.paymentPlan = this.cashFlow.paymentPlan;
            if(this.paymentPlan == "Fija"){
                // this.cashFlowMonths = this.generateArray1(this.cashFlowData.months);
            }
            else if(this.paymentPlan == "Pactada") {
                this.quotaType = "CUOTA PACTADA";
                // this.cashFlowMonths = this.generateArray2(this.cashFlowData.months);
            }
            if (!this.validateCustomerAge()) {
               this.showNotificationError('La edad del cliente no ha sido diligenciada.');
            }
            
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .highlight-red {
        font-weight: bold;
        color: red;
    }
    .yellow-background {
        background-color: yellow;
        color: black; /* Texto negro por defecto */
    }
    .top-right-button {
        position: absolute;
        top: 10px; /* Ajusta el espacio desde el borde superior */
        right: 10px; /* Ajusta el espacio desde el borde derecho */
    }
</style>
